import React from 'react';
import PropTypes from 'prop-types';
import './HeroSection.scss';
import Button from '@ids/button';

import {
  convertToSnakeCase,
  getImageSrc,
  isTaxFormUnavailable,
  taxFormsNextAvlDate,
} from '../../Util/CommonUtils';

const HeroSection = (props) => {
  const getElementOffsetTop = (element, offsetTopAccumulator = 0) => {
    if (element.offsetParent !== null) {
      return getElementOffsetTop(element.offsetParent, offsetTopAccumulator + element.offsetTop);
    }
    return offsetTopAccumulator;
  };

  const scrollTo = (index) => {
    const element = document.getElementsByClassName(props.navBodyClass)[index];
    const headerHeight = document.getElementById('headerInfo').offsetHeight;
    const stickyHeight = document.getElementsByClassName('stickyNav')[0].offsetHeight;
    const scrollToElement = getElementOffsetTop(element) - headerHeight - stickyHeight;
    window.scroll({ top: scrollToElement, behaviour: 'smooth' });
  };

  const navLinkAction = (index, e) => {
    e.preventDefault();
    scrollTo(index);
  };

  return (
    <div className="row heroContainer">
      <div className="col-lg-6 col-xs-12">
        {props.Header && <h2>{props.Header}</h2>}
        {isTaxFormUnavailable() && props.unavailableMsg ? (
          <p className="hero-description" data-test-attr="product-unavailble-msg">
            {props.unavailableMsg.replace('[DATE]', taxFormsNextAvlDate())}
          </p>
        ) : (
          <>
            {props.Desc && (
              <p className="hero-description" data-test-attr="hero-description">
                {props.Desc}
              </p>
            )}
            {props.Action && props.Action.Type === 'LINK' && (
              <Button
                theme="intuit"
                buttonType="primary"
                className="hero-button"
                data-wa-link=""
                data-wa-event="Pre-Printed W-2 Kits"
                onClick={(e) => navLinkAction(props.Action.Index, e)}
                data-test-attr="hero-button"
                data-ui-object="button"
                data-refer-ui-access-point={`${convertToSnakeCase(
                  props.Action.Text,
                )} | pre_printed_w_2_kits`}
              >
                {props.Action.Text}
              </Button>
            )}
          </>
        )}
      </div>
      <div className="col-lg-6 col-xs-12">
        {props.Image && props.ImageAltText && (
          <img
            alt={props.ImageAltText}
            src={getImageSrc(props.Image)}
            className="pull-right"
            data-test-attr="hero-img"
          />
        )}
      </div>
    </div>
  );
};

HeroSection.propTypes = {
  Header: PropTypes.string,
  Desc: PropTypes.string,
  Image: PropTypes.string,
  ImageAltText: PropTypes.string,
  Action: PropTypes.object,
};

export default HeroSection;
